// import { Paper } from "@material-ui/core";
import { Title, useTabStyle } from "App/Component/ui";
import React, { Suspense } from "react";

import { FormProvider } from "./context/FormContext";
import { TabMaster } from "./ui";

export default function InputFixedAsset({
  changePage,
  data,
  menu,
  changeParentData,
}) {
  const classes = useTabStyle();

  return (
    <Suspense fallback={<div> Loading Input Fixed Asset Component...</div>}>
      <FormProvider data={data} menu={menu}>
        <div className={classes.root}>
          <Title title={"Input Fixed Asset"} />
          {/* <TabMaster changePage={changePage} /> */}
          <TabMaster menu={menu} changeParentData={changeParentData} />
          {/* <ul
          style={{
            fontSize: "11px",
            marginTop: "2rem",
            padding: "1rem",
          }}>
          <li>Gunakan F2 untuk memunculkan modal muat kunjungan</li>
          <li>Gunakan F4 untuk memunculkan modal muat list penjualan</li>
          <li>Gunakan F6 untuk untuk reset form penjualan</li>
        </ul> */}
        </div>
      </FormProvider>
    </Suspense>
  );
}
